import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

// 管理支付页面之间需要延续的少量会话状态。
export const usePayStore = defineStore(
    'payStore',
    () => {
        const hasPaid = ref(false)
        const hasPaidAction = reactive({
            save(value = true) {
                hasPaid.value = value
            },
            clear() {
                hasPaid.value = false
            },
            consume() {
                const value = hasPaid.value
                hasPaid.value = false
                return value
            },
            data: hasPaid,
        })

        const pGid = ref('')
        const pGidAction = reactive({
            save(value: string) {
                pGid.value = value
            },
            clear() {
                pGid.value = ''
            },
            data: pGid,
        })

        return {
            hasPaid,
            hasPaidAction,
            pGid,
            pGidAction,
        }
    },
    {
        persist: {
            enabled: true,
            strategies: [
                { key: 'payStore', storage: sessionStorage, paths: ['hasPaid', 'pGid'] },
            ],
        },
    }
)
